export default __webpack_public_path__ + "static/media/logo-app2j.65593057.svg";